module.exports = __webpack_public_path__ + "static/media/volunteer2.9af9406f.jpg";